import { Typography } from "@flash-tecnologia/hros-web-ui-v2";
import React from "react";
import { Box } from "../../atoms";
import { Header, Option } from "./option-picker.styles";

export interface OptionPickerProps {
  title: string;
  options: { text: string; value: string }[];
  leftSlot?: React.ReactNode;
  value?: string;
  onChange: (value: string) => void;
}

export const OptionPicker = ({
  leftSlot,
  title,
  options,
  value,
  onChange,
}: OptionPickerProps) => {
  return (
    <Box flexDirection="column" $width="100%">
      <Header alignItems="center" gap="xs3">
        {leftSlot}
        <Typography.Headline9 color="neutral.30">{title}</Typography.Headline9>
      </Header>
      <Box>
        {options.map((option) => (
          <Option
            key={option.value}
            $selected={value === option.value}
            onClick={() => onChange(option.value)}
          >
            <Typography.Body4 color="neutral.40" weight={700}>
              {option.text}
            </Typography.Body4>
          </Option>
        ))}
      </Box>
    </Box>
  );
};
